module.exports = __webpack_public_path__ + "img/banner-concurso.46970dea.jpg";